import React from "react";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import CommonLayout from "./CommonLayout";
import { useAuthStore } from "../../stores/Auth.store";
import { useNavigate } from "react-router-dom";
import { useOrders } from "../../hooks/collections/useOrdersV2";
import { BadgeOrder } from "../../components/OrderStatus/BadgeOrder";
import { OrderStatusEnum } from "../../enums/OrderStatus.enum";
import { Collections } from "../../@core/constants/FirebasePaths";
import { NotFound } from "../../components/NotFound/NotFound";
import { IOrder } from '../../@core/interfaces/IOrder';

const AccountOrders = () => {
  const navigate = useNavigate();
  const userId = useAuthStore((state) => state.uid);
  const { getReference } = useOrders({ loadData: false})
  const { orders } = useOrders({
    loadData: true,
    queries: [
      {
        type: "where",
        field: "createdBy",
        operator: "==",
        value: getReference(`${Collections.users._path}/${userId}`)
      },
      { type: "orderBy", field: "createdAt", direction: "desc" }
    ]
  });

  const isCheckoutValid = (order: any) => {
    if (order.status !== OrderStatusEnum.GENERATED) return false;

    const now = Date.now();
    const secondsIn15Min = 900;
    const diffInSeconds = Math.floor((now - order.createdAt) / 1000);

    return diffInSeconds < secondsIn15Min;
  };

  const renderSection1 = () => {
    return (
      <div className="space-y-6 sm:space-y-8">
        <div>
          <h2 className="text-3xl font-semibold">My orders</h2>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className={"overflow-x-auto"}>
          {orders.length ? (
            <table className={"w-full text-left min-w-[1000px] border-separate border-spacing-4"}>
              <thead>
              <tr>
                <th>Service name</th>
                <th>Status</th>
                <th>Location</th>
                <th>Total</th>
                <th></th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              {orders?.map((order: IOrder) => (
                <tr key={order.id}>
                  <td>{order.service?.title}</td>
                  <td><BadgeOrder status={order.status}/></td>
                  <td>{order.service?.details.location.address}</td>
                  <td>${order.total}</td>
                  <td>
                    <ButtonSecondary onClick={() => navigate(`/order-detail/${order.id}`)}>View
                      Details</ButtonSecondary>
                  </td>
                  <td>
                    {isCheckoutValid(order) && (
                      <ButtonPrimary onClick={() => navigate(`/checkout?orderId=${order.id}`)}>
                        Return to Checkout
                      </ButtonPrimary>
                    )}
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          ) : (
            <NotFound description={"No orders found from you."} />
          )}
        </div>
      </div>
    );
  };

  return (
    <div>
      <CommonLayout>{renderSection1()}</CommonLayout>
    </div>
  );
};

export default AccountOrders;
